var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteImports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 70,
    viewBox: "0 0 216 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 40.726V60a4 4 0 0 0 4 4h77a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H71.513c1.113-2.891 4.577-5 8.679-5h126.754c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7H155.21c5 0 9.053 3.134 9.053 7s-4.053 7-9.053 7h28.455c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7h-13.16c-6.304 0-11.415 3.134-11.415 7 0 2.577 2.587 4.91 7.76 7 5 0 9.054 3.134 9.054 7s-4.053 7-9.054 7H59.497c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H9.054C4.054 56 0 52.866 0 49s4.054-7 9.054-7H60.79c1.94 0 3.737-.471 5.21-1.274Zm0-11.452C64.527 28.471 62.73 28 60.79 28H28.455c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H66v15.274ZM206.946 42c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7S216 31.134 216 35s-4.054 7-9.054 7Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5,
    transform: "translate(66 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 82.5,
    height: 56.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.996 8.806H15.877M11.496 8.806H1.753M82.391 8.806H15.877M11.496 8.806H1.753",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.372 45.54c4.568-11.867 13.163-18.129 25.786-18.786 18.933-.986 27.62 16.005 27.62 16.005",
    strokeWidth: 2.5,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.13 43.501 9.967 4.486M135.532 37.17l1.565 10.817"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteImports);
export default __webpack_public_path__ + "static/media/website-imports.23f1fa6d21577f18fffb69dec4b2b72e.svg";
export { ForwardRef as ReactComponent };